module.exports = __webpack_public_path__ + "static/cai_insights_reports_transparent-3d352e35ec85670d68db0e6c8a817a1b.png";